import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

// Shared colored KPI tile for dashboards/reports (e.g. the Yearly CTC summary in
// MyPayslips.tsx). The `h5` and `caption` Typography variants have an explicit text color
// baked into the theme (theme.ts) for use on plain white surfaces — that color wins over the
// `white` inherited from this card's background, which made the value/caption unreadable on
// a solid color tile. Every text color here is set explicitly instead of inherited so this
// stays correct regardless of theme changes elsewhere.

export type StatCardTone = 'primary' | 'success' | 'error' | 'warning' | 'info' | 'successDark';

const toneBg: Record<StatCardTone, string> = {
  primary: 'primary.main',
  success: 'success.main',
  error: 'error.main',
  warning: 'warning.main',
  info: 'info.main',
  successDark: 'success.dark',
};

export interface StatCardProps {
  tone?: StatCardTone;
  label: React.ReactNode;
  value: React.ReactNode;
  caption?: React.ReactNode;
  minWidth?: number | string;
  sx?: object;
}

export const StatCard: React.FC<StatCardProps> = ({ tone = 'primary', label, value, caption, minWidth = 180, sx }) => (
  <Card sx={{ flex: 1, minWidth, bgcolor: toneBg[tone], ...sx }}>
    <CardContent>
      <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.85)' }}>{label}</Typography>
      <Typography variant="h5" fontWeight="bold" sx={{ color: '#fff' }}>{value}</Typography>
      {caption && (
        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.75)', display: 'block' }}>
          {caption}
        </Typography>
      )}
    </CardContent>
  </Card>
);

export default StatCard;
